// extracted by mini-css-extract-plugin
module.exports = {"header":"Title_header__Vw77N","title":"Title_title__1CPaa","backButton":"Title_backButton__14PAj","button":"Title_button__1Rzpd","secondaryButton":"Title_secondaryButton__9pkS4"};